import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/reset.css'

import { Switch, Scroll, Icon } from 'view-design'
import 'view-design/dist/styles/iview.css'

Vue.component('i-switch', Switch)
Vue.component('i-scroll', Scroll)
Vue.component('i-icon', Icon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
